(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["muckis-laden"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__muckisMapInit) return;
  window.__muckisMapInit = true;

  var KEY = 'muckis-maps-consent';

  function loadMap(box) {
    if (!box || box.getAttribute('data-loaded') === 'true') return;
    var src = box.getAttribute('data-map-src');
    if (!src) return;
    var frame = document.createElement('iframe');
    frame.className = 'muckis-laden__iframe';
    frame.src = src;
    frame.title = box.getAttribute('data-map-title') || 'Karte';
    frame.loading = 'lazy';
    frame.referrerPolicy = 'no-referrer-when-downgrade';
    frame.allowFullscreen = true;
    box.innerHTML = '';
    box.appendChild(frame);
    box.setAttribute('data-loaded', 'true');
  }

  function loadAll() {
    var boxes = document.querySelectorAll('[data-muckis-map]');
    for (var i = 0; i < boxes.length; i++) loadMap(boxes[i]);
  }

  function initFromSession() {
    try {
      if (window.sessionStorage.getItem(KEY) === '1') loadAll();
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-muckis-map-consent]');
    if (!btn) return;
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {}
    loadAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromSession);
  } else {
    initFromSession();
  }
  document.addEventListener('shopify:section:load', initFromSession);
})();

  } catch(e) { console.error(e); }
})();
})();
